





















































import { Component, Prop, Vue } from 'vue-property-decorator'
import Radio from '@/components/Radio/index.vue'
import Select from '@/components/Select/index.vue'
import Form from '@/form'
import { hasOwnProp, isObjectEmpty } from '@/utils'

@Component({
  components: {
    Radio,
    Select
  }
})

export default class CustomForm extends Vue {
  @Prop({ type: Object }) field!: any
  @Prop({ type: Array, required: true }) setup!: any

  // __DATA
  private form: any = new Form(this.field)

  // __METHODS
  private touch (): void {
    this.$validator.validate()
      .then(valid => {
        if (valid) {
          this.$emit('callback', this.form.data())
        }
      })
  }

  private typeOf (val: string): string {
    const chuck: boolean = ['checkbox', 'radio', 'select'].indexOf(val) > -1
    return chuck ? 'hidden' : val
  }

  // __COMPUTED
  private get isModify (): boolean {
    const result: any = this.field && (hasOwnProp(this.field, 'id') && this.field.id)
    return Boolean(result)
  }
}
